import { XsrfResilient } from '@/services/TypedHelpers'
import { log } from '@/services/Log'
import type { BCStoreFrontOrderType } from '@/types/BigCommerce/BCStoreFrontOrder'
import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'

export const getOrderWithPayments = XsrfResilient(async ({ orderId }: { orderId: string }) => {
  log('getOrderWithPayments for ', orderId)
  const include = [
    'payments',
    'lineItems.physicalItems.socialMedia',
    'lineItems.physicalItems.options',
    'lineItems.digitalItems.socialMedia',
    'lineItems.digitalItems.options',
  ]
  const options = include?.length ? { params: { include: include.join(',') } } : undefined
  // Returns Order data. - https://developer.bigcommerce.com/api-reference/storefront/orders/order/ordersbyorderidget
  // This will return order data immediately after an order is placed on the storefront.
  const [
    { default: Axios },
    { assertBCStoreFrontOrder },
    { standardizeAddressFromBigCommerce },
    { generateLineItemsFromOrder },
    { standardizeOrderComplete },
  ] = await allPromisesWithRetries(() => [
    import('axios'),
    import('@/types/BigCommerce/BCStoreFrontOrder'),
    import('@/services/Standardizers/standardizeAddressFromBigCommerce'),
    import('@/services/FramedCheckout/orderServices/generateLineItemsFromOrder'),
    import('@/services/Standardizers/standardizeOrderComplete'),
  ])
  const order = (await Axios.get<BCStoreFrontOrderType>(`/api/storefront/orders/${orderId}`, options)).data
  assertBCStoreFrontOrder(order)
  const lineItems = await generateLineItemsFromOrder(order)
  lineItems.sort((a, b) => (a.sku > b.sku && 1) || -1)
  return standardizeOrderComplete({
    ...order,
    billingAddress: standardizeAddressFromBigCommerce(order.billingAddress),
    email: String(order.billingAddress.email),
  }, lineItems)
})

export default getOrderWithPayments
